import { Divider } from 'react-native-paper';

interface InsetDividerProps {
  readonly inset?: number;
}

export const InsetDivider = ({ inset = 16 }: InsetDividerProps) => (
  <Divider style={{ marginHorizontal: inset }} />
);
